import { createSvgIcon } from "@mui/material";
export const LogoIconWhite = createSvgIcon(
	<svg
		width="568"
		height="568"
		viewBox="0 0 568 568"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M214.857 28H137.714C64.5715 28 28 64.5715 28 137.714L28 430.286C28 503.429 64.5714 540 137.714 540H220.207C292.735 540 379.289 540 430.286 540C503.429 540 540 503.429 540 430.286V137.714C540 64.5714 503.429 28 430.286 28L338.857 28C320.571 28 284 36 284 82.8572V210.857M284 210.857V466.857M284 210.857H393.714"
			stroke="white"
			stroke-width="56"
			stroke-miterlimit="2.24116"
			stroke-linecap="round"
		/>
	</svg>,
	"LogoIconWhite"
);
